export namespace AdirDetailsSideNavigation {
  export const SIDE_NAVIGATION_OPTION_LABEL = {
    MILESTONE_REVIEW_REQUEST_FORM: 'Milestone Review Request Form',
    MINUTES_OF_MEETING: 'Minutes of Meeting',
    ATTACHMENTS: 'Attachments',
    PARTICIPANTS: 'Participants',
    CONVERSE: 'Converse',
    ACTIVITY_LOGS: 'Activity Logs',
  };

  export type SideNavigationOption = {
    label: string;
    link: string;
    iconName: string;
    isDisabled: boolean;
  };

  export type SideNavigationOptions = SideNavigationOption[];
}
